var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"ma-2",attrs:{"color":"primary"},on:{"click":_vm.changeTheme}},[_vm._v(" mdi-theme-light-dark ")])
}
var staticRenderFns = []

export { render, staticRenderFns }